import constants from 'common/constants'
import {
  ATTENDANCE_ADD_ATTENDANCE_REMARKS,
  ATTENDANCE_CHECKOUT_DEAILS,
  ATTENDANCE_SETTING,
  ATTENDANCE_SETTINGS_BY_BRANCH,
  ATTENDANCE_SETTING_CREATE,
  ATTENDANCE_UPLOAD,
  GENERATE_DATEWISE_DETAILED_ATTENDANCE_REPORT,
  GENERATE_STUDENT_CLASSWISE_SUMMARY_REPORT,
  GENERATE_STUDENT_COMBINE_ATTENDANCE_REPORT,
  GENERATE_STUDENT_INDIVIDUAL_ATTENDANCE_REPORT,
  GENERATE_STUDENT_MONTHWISE_REPORT,
  GENERATE_STUDENT_SUBJECTWISE_SUMMARY_REPORT,
  GENERATE_STUDENT_SUBJECT_COMBINED_ATTENDANCE_REPORT,
  GENERATE_STUDENT_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT,
  GENERATE_STUDENT_SUBJECT_MONTHLY_ATTENDANCE_REPORT,
  GENERATE_STUDENT_SUBJECT_MONTHLY_REPORT,
  GENERATE_TEACHER_STAFF_COMBINE_ATTENDANCE_REPORT,
  GENERATE_TEACHER_STAFF_INDIVIDUAL_ATTENDANCE_REPORT,
  GENERATE_TEACHER_STAFF_MONTHLY_COMBINE_ATTENDANCE_REPORT,
  GENERATE_TEACHER_SUBJECT_COMBINE_ATTENDANCE_REPORT,
  GENERATE_TEACHER_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT,
  GENERATE_TEACHER_SUBJECT_ROSTER_ATTENDANCE_REPORT,
  GET_STD_MOTNTHWISE_ATTENDANCE,
  GET_TODAY_ATTENDANCE,
  MARK_USER_ATTENDANCE,
  SEND_ATTENDANCE_WARNING,
  UNMARK_USER_ATTENDANCE,
  UPDATE_ATTENDANCE_SETTING,
  UPDATE_USER_ATTENDANCE,
} from 'setup/redux/Actions/Attendance/ActionTypes/ApiActionTypes'

import {
  REDUX_GET_ATTENDANCE_SETTING,
  REDUX_UPDATE_ATTENDANCE_SETTING,
} from './ActionTypes/ReduxAtionTypes'

export const uploadBiometricAttendanceCSV = (body, onSuccess, onFailure) => {
  return {
    type: ATTENDANCE_UPLOAD,
    payload: {
      apiUrl: constants.api_biometric_attendance,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'multipart/form-data',
      header2: {
        'api-key': 'randomAuthKey',
      },
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}

export const getTodayAttendance = (data, onSuccess, onFailure) => {
  return {
    type: GET_TODAY_ATTENDANCE,
    payload: {
      apiUrl: constants.api_get_today_attendance_by_id,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const getStdMonthWiseAttendance = (data, onSuccess, onFailure) => {
  return {
    type: GET_STD_MOTNTHWISE_ATTENDANCE,
    payload: {
      apiUrl: constants.api_get_std_month_attendance_by_id,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const attendanceSettingsByBranchIds = (data, onSuccess, onFailure) => {
  return {
    type: ATTENDANCE_SETTINGS_BY_BRANCH,
    payload: {
      apiUrl: constants.api_attendance_settings_by_branch,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: REDUX_GET_ATTENDANCE_SETTING,
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const markAttendance = (data, onSuccess, onFailure) => {
  return {
    type: MARK_USER_ATTENDANCE,
    payload: {
      apiUrl: constants.api_attendance_mark_attendance,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const unmarkAttendance = (data, onSuccess, onFailure) => {
  return {
    type: UNMARK_USER_ATTENDANCE,
    payload: {
      apiUrl: constants.api_attendance_unmark_attendance,
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const updateAttendance = (data, onSuccess, onFailure) => {
  return {
    type: UPDATE_USER_ATTENDANCE,
    payload: {
      apiUrl: constants.api_attendance_update_attendance,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const getAttendanceSetting = (data, onSuccess, onFailure) => {
  return {
    type: ATTENDANCE_SETTING,
    payload: {
      apiUrl: constants.api_get_attendance_setting,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const getCheckoutDetails = (data, onSuccess, onFailure) => {
  return {
    type: ATTENDANCE_CHECKOUT_DEAILS,
    payload: {
      apiUrl: constants.api_attendance_checkout_details,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const updateAttendanceSetting = (data, onSuccess, onFailure) => {
  return {
    type: UPDATE_ATTENDANCE_SETTING,
    payload: {
      apiUrl: constants.api_update_attendance_setting,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const addAttendanceRemarks = (data, onSuccess, onFailure) => {
  return {
    type: ATTENDANCE_ADD_ATTENDANCE_REMARKS,
    payload: {
      apiUrl: constants.api_attendance_add_remarks,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateIndividualAttendanceReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_TEACHER_STAFF_INDIVIDUAL_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_individual_attendance_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateTeacherStaffCombineAttendanceReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_TEACHER_STAFF_COMBINE_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_combine_attendance_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateTeacherStaffMonthlyCombineAttendanceReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_TEACHER_STAFF_MONTHLY_COMBINE_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_combine_monthly_attendance_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateTeacherSubjectIndividualAttendanceReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_TEACHER_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_teacher_subject_individual_attendance_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateTeacherSubjectCombineAttendanceReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_TEACHER_SUBJECT_COMBINE_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_teacher_subject_combine_attendance_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateTeacherSubjectRosterAttendanceReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_TEACHER_SUBJECT_ROSTER_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_teacher_subject_roster_attendance_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      responseType: 'blob',
      onSuccess,
      onFailure,
    },
  }
}

export const generateStudentSubjectIndividualAttendanceReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_student_subject_individual_attendance_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateStudentSubjectCombineAttendanceReport = (body, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_SUBJECT_COMBINED_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_student_subject_combine_attendance_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}

export const generateStudentSubjectMonthlyAttendanceReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_SUBJECT_MONTHLY_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_student_subject_monthly_attendance_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
export const generateStudentIndividualAttendanceReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_INDIVIDUAL_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_student_individual_attendance_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateStudentCombineAttendanceReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_COMBINE_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_student_combine_attendance_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateStudentClasswiseSummaryReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_CLASSWISE_SUMMARY_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_student_classwise_summary_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateStudentSubjectwiseSummaryReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_SUBJECTWISE_SUMMARY_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_student_subjectwise_summary_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateStudentMonthwiseReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_MONTHWISE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_student_monthwise_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateStudentSubjectMonthlyReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_SUBJECT_MONTHLY_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_student_subject_monthly_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const generateDatewiseDetailedAttendanceReport = (data, onSuccess, onFailure) => {
  return {
    type: GENERATE_DATEWISE_DETAILED_ATTENDANCE_REPORT,
    payload: {
      apiUrl: constants.api_attendance_generate_student_subject_datewise_detailed_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const attendanceSettingCreate = (data, onSuccess, onFailure) => {
  return {
    type: ATTENDANCE_SETTING_CREATE,
    payload: {
      apiUrl: constants.api_attendance_setting_create,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: REDUX_GET_ATTENDANCE_SETTING,
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const sendAttendanceWarning = (data, onSuccess, onFailure) => {
  return {
    type: SEND_ATTENDANCE_WARNING,
    payload: {
      apiUrl: constants.api_attendance_send_warning,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const updateAttendanceSettingStore = (level_ids, updatedFields) => ({
  type: REDUX_UPDATE_ATTENDANCE_SETTING,
  payload: {
    level_ids,
    updatedFields,
  },
})
